(ns frontend.view.modals.folder-management-check-lists-modal.event
  (:require
   [clojure.set :as set]
   [common.util :as cu]
   [frontend.controller.websocket.event :as ws]
   [frontend.logging :as logging]
   [frontend.view.modals.folder-management-check-lists-modal.sub :as sub]
   [re-frame.core :as rf]))


(rf/reg-event-fx
 ::init
 (fn [{db :db} [_ entity]]
   (let [selected-check-list-ids (:pipeline/checklist-configurations entity)
         target-entity-type (:pipeline/entity-type entity)
         selected-check-list-ids (->> selected-check-list-ids
                                      (map (fn [id]
                                             (cond (number? id)
                                                   id
                                                   (:db/id id)
                                                   (:db/id id)
                                                   :else
                                                   id)))
                                      (set))]
     {:db (-> db
              (assoc ::sub/target-entity-id (:db/id entity))
              (assoc ::sub/target-entity-type target-entity-type)
              (assoc ::sub/original-list-ids selected-check-list-ids)
              (assoc ::sub/selected-check-lists selected-check-list-ids))})))

(rf/reg-event-fx
 ::clear
 (fn [{db :db} _]
   {:db (-> db
            (dissoc ::sub/target-entity-id
                    ::sub/original-list-ids
                    ::sub/target-entity-type
                    ::sub/selected-check-lists
                    ::sub/processing?
                    ::sub/edit-list
                    ::sub/edit-list-original))}))

(rf/reg-event-fx
 ::set-selected
 (fn [{db :db} [_ list-id selected?]]
   (let [selected-list-ids (get db ::sub/selected-check-lists)]
     {:db (assoc db
                 ::sub/selected-check-lists
                 (if selected?
                   (set/union (set selected-list-ids) #{list-id})
                   (set/difference (set selected-list-ids) #{list-id})))})))

(rf/reg-event-fx
 ::start-edit
 (fn [{db :db} [_ list]]
   {:db (-> db
            (assoc ::sub/edit-list list
                   ::sub/edit-list-original list))}))

(rf/reg-event-fx
 ::add-field
 (fn [{db :db} [_ arg]]
   {:db (-> db
            (update-in [::sub/edit-list :check-list/configuration]
                       (fn [old-list]
                         (vec (concat old-list [arg])))))}))

(rf/reg-event-fx
 ::remove-field
 (fn [{db :db} [_ field]]
   {:db (-> db
            (update-in [::sub/edit-list :check-list/configuration]
                       (fn [old-list]
                         (->> old-list
                              (remove (fn [i]
                                        (= i field)))
                              (vec)))))}))
(rf/reg-event-fx
 ::on-sort-end
 (fn [{db :db} [_ start-index end-index]]
   {:db (update-in db
                   [::sub/edit-list :check-list/configuration]
                   (fn [old-list]
                     (if (and start-index
                              (>= start-index 0)
                              (< start-index (count old-list))
                              (>= end-index 0)
                              (< end-index (count old-list)))
                       (cu/vec-move (vec old-list) start-index end-index)
                       (vec old-list))
                   ))}))

(rf/reg-event-fx
 ::check-list-name-change
 (fn [{db :db} [_ new-name]]
   {:db (-> db
            (assoc-in [::sub/edit-list :check-list/label] new-name))}))

(rf/reg-event-fx
 ::save-ok
 (fn [{db :db} [_ close-modal! resp]]
   (when (fn? close-modal!)
     (close-modal!))
   {:db (dissoc db ::sub/processing?)}))

(rf/reg-event-fx
 ::save-failed
 (fn [{db :db} [_ resp]]
   (let [error (some->> resp
                        :body
                        :error-message)]
     (logging/warn (str ::save-failed " Save check-list failed" resp))
     {:db (-> db
              (dissoc ::sub/processing?)
              (assoc ::sub/error error))})))

(rf/reg-event-fx
 ::save!
 (fn [{db :db} [_ entity close-modal!]]
   (let [entity-id (get db ::sub/target-entity-id)
         selected-list-ids (get db ::sub/selected-check-lists)
         msg {:db/id     entity-id
              :attribute :pipeline/checklist-configurations
              :value     (set selected-list-ids)}]
     {:db       (assoc-in db [::sub/processing?] true)
      ::ws/send {:id         :entity/update-attribute
                 :body       msg
                 :on-success [::save-ok close-modal!]
                 :on-error   [::save-failed]}})))

(rf/reg-event-fx
 ::save-list!-ok
 (fn [{db :db} [_ resp]]
   {:db (dissoc db
                ::sub/processing?
                ::sub/edit-list-original
                ::sub/edit-list)}))


(rf/reg-event-fx
 ::save-list!-failed
 (fn [{db :db} [_ resp]]
   (let [error (some->> resp
                        :body
                        :error-message)]
     (js/console.error "Save list! failed" resp)
     {:db (-> db
              (dissoc ::sub/processing?)
              (assoc ::sub/error error))})))

(rf/reg-event-fx
 ::save-list!
 (fn [{db :db} _]
   (let [edited-list (get db ::sub/edit-list)
         msg {:db/id (:db/id edited-list)
              :data  {:check-list/label         (:check-list/label edited-list)
                      :check-list/configuration (pr-str (vec (:check-list/configuration edited-list)))}}]
     {:db       (assoc-in db [::sub/processing?] true)
      ::ws/send {:id         :entity/update-attributes
                 :body       msg
                 :on-success [::save-list!-ok]
                 :on-error   [::save-list!-failed]}})))
